import { SignupFormType } from "../../types/plan.type";
import * as yup from "yup";

export type SignupRequest = Omit<SignupFormType, "smsConsent"> & {
	notifyBySms: boolean;
};

export const smsConsentSchema = yup.boolean().default(false);

export function signupRecoveryRedirect(path: string, search: string): string {
	if (!path || (path !== "/pet-register" && !path.startsWith("/client/pet/update/"))) return path;
	const url = new URL(path, "https://fetch.peeva.co");
	if (url.pathname !== "/pet-register" && url.searchParams.get("resumeSignup") !== "true") return path;
	const promo = new URLSearchParams(search).get("promo");
	if (promo) url.searchParams.set("promo", promo);
	return `${url.pathname}${url.search}`;
}

export function resolveSignupEmail(searchParams: URLSearchParams, storedEmail?: string): string {
	const queryEmail = searchParams.get("email")?.trim();
	return queryEmail || storedEmail?.trim() || "";
}

export function buildSignupRequest(values: SignupFormType): SignupRequest {
	const { smsConsent, ...account } = values;
	return {
		...account,
		notifyBySms: smsConsent,
	};
}

export function buildSignupFormPath(promo?: string | null): string {
	const searchParams = new URLSearchParams();
	if (promo) {
		searchParams.set("promo", promo);
	}
	const query = searchParams.toString();
	return `/sign-up-form${query ? `?${query}` : ""}`;
}
